import React from 'react';
import { FormattedMessage } from 'react-intl';

function SimpleRow(props) {
  const { translationKey, value, className } = props;

  return (
    <tr>
      <td className={`${translationKey === 'messages.no_data' ? 'font-weight-bold text-center' : ''}`}>
        <FormattedMessage id={translationKey} />
      </td>
      <td className={`${className ? className : ''}`}>
        {props.children ? props.children : null}
        {value && !props.children ? value : null}
      </td>
    </tr>
  );
}

export { SimpleRow };
